import React, { useState, useEffect } from 'react';
import { blogApi, resumeApi } from '../services/api';

const Dashboard: React.FC = () => {
  const [totalPosts, setTotalPosts] = useState(0);
  const [publishedPosts, setPublishedPosts] = useState(0);
  const [loading, setLoading] = useState(true);
  const [resumeRefreshing, setResumeRefreshing] = useState(false);
  const [resumeStatus, setResumeStatus] = useState<string | null>(null);

  useEffect(() => {
    blogApi.getAllPosts()
      .then(posts => {
        setTotalPosts(posts.length);
        setPublishedPosts(posts.filter(p => p.isPublished).length);
      })
      .catch(error => console.error('Error loading posts:', error))
      .finally(() => setLoading(false));
  }, []);

  const handleResumeRefresh = async () => {
    setResumeRefreshing(true);
    setResumeStatus(null);
    try {
      const { fetchedAt } = await resumeApi.refresh();
      setResumeStatus(`Refreshed at ${new Date(fetchedAt).toLocaleString()}`);
    } catch (error) {
      console.error('Error refreshing resume:', error);
      setResumeStatus('Refresh failed. Check server logs.');
    } finally {
      setResumeRefreshing(false);
    }
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '2rem' }}>
      <h1 style={{ marginBottom: '2rem', color: '#333' }}>Dashboard</h1>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '1.5rem',
        marginBottom: '3rem'
      }}>
        <div style={{
          background: 'white',
          padding: '1.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
          textAlign: 'center'
        }}>
          <h3 style={{ marginBottom: '1rem', color: '#666', fontSize: '1rem' }}>Blog Posts</h3>
          <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#007bff', marginBottom: '0.5rem' }}>
            {loading ? '—' : totalPosts}
          </div>
          <div style={{ color: '#666', fontSize: '0.9rem' }}>
            {loading ? '' : `${publishedPosts} published`}
          </div>
        </div>
      </div>

      <div style={{
        background: 'white',
        padding: '1.5rem',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
      }}>
        <h2 style={{ color: '#333', marginBottom: '1.5rem' }}>Quick Actions</h2>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', alignItems: 'center' }}>
          <a href="/blog" style={{
            padding: '0.75rem 1.5rem',
            textDecoration: 'none',
            borderRadius: '6px',
            fontWeight: '500',
            backgroundColor: '#007bff',
            color: 'white'
          }}>
            Manage Blog Posts
          </a>
          <button
            onClick={handleResumeRefresh}
            disabled={resumeRefreshing}
            style={{
              padding: '0.75rem 1.5rem',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '500',
              backgroundColor: resumeRefreshing ? '#6c757d' : '#28a745',
              color: 'white',
              cursor: resumeRefreshing ? 'default' : 'pointer'
            }}
          >
            {resumeRefreshing ? 'Refreshing Resume…' : 'Force Refresh Resume'}
          </button>
          {resumeStatus && (
            <span style={{ color: '#666', fontSize: '0.9rem' }}>{resumeStatus}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
